const Finanzas = () => {
    return (
      <div className="text-center mt-10">
        <h2 className="text-2xl font-semibold text-blue-700">Vista: Finanzas</h2>
        <p className="mt-4 text-gray-600">Aquí podrás ver balances, ingresos y egresos.</p>
      </div>
    );
  };
  
  export default Finanzas;
  